import { View } from 'react-native';
const ScreenStack = View;
export default ScreenStack;
//# sourceMappingURL=ScreenStack.web.js.map